import { render } from "./TransactionForm.vue?vue&type=template&id=535d1536&scoped=true"
import script from "./TransactionForm.vue?vue&type=script&lang=js"
export * from "./TransactionForm.vue?vue&type=script&lang=js"

import "./TransactionForm.vue?vue&type=style&index=0&id=535d1536&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535d1536"]])

export default __exports__